import React, { useEffect, useRef, useState } from "react";

const Gameiosign = () => {
  const audioRef = useRef(null);
  const [muted, setMuted] = useState(false);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = 0.4;
      audioRef.current.play().catch(() => {});
    }
  }, []);

  const toggleSound = () => {
    if (audioRef.current) {
      audioRef.current.muted = !audioRef.current.muted;
      setMuted(!muted);
    }
  };

  return (
    <div className="relative w-screen h-screen overflow-hidden flex items-center justify-center bg-black text-white">

      {/* 🎵 Background Sound */}
      <audio ref={audioRef} loop>
        <source src="/assets/sound/battle.mp3" type="audio/mpeg" />
      </audio>

     

      {/* 🌌 Dark Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#0f0f1f] via-black to-[#1a0033]"></div>

      {/* ⚡ Animated Grid Lines */}
      <div className="absolute inset-0 animated-grid"></div>

      {/* 🔥 Scanning Neon Line */}
      <div className="absolute inset-0 scanning-line"></div>

      {/* 🌠 Floating Particles */}
      <div className="absolute inset-0 particles"></div>

      {/* Content */}
      <div className="relative z-10 text-center w-full max-w-md px-6 backdrop-blur-xl bg-white/5 p-10 rounded-3xl border border-white/10 shadow-2xl">

        <h1 className="text-4xl font-bold mb-6 bg-gradient-to-r from-purple-400 to-pink-500 bg-clip-text text-transparent animate-gradient">
          GAME LOGIN
        </h1>

        <p className="text-gray-400 mb-8">
          Enter your mobile number to enter the battlefield.
        </p>

        <input
          type="text"
          placeholder="Enter Mobile Number"
          className="w-full p-4 text-lg rounded-lg outline-none mb-6 bg-black/40 text-white placeholder-gray-400 border border-white/20 focus:border-pink-500 focus:shadow-[0_0_15px_#ff00ff] transition duration-300"
        />

        <button className="w-full py-3 rounded-xl text-lg font-semibold login-btn">
          LOGIN
        </button>

        <div className="mt-8 text-gray-400 text-sm">
          NOT Subscribed yet?{" "}
          <span className="text-pink-400 cursor-pointer hover:text-white transition">
            JOIN NOW
          </span>{" "}
          |{" "}
          <span className="cursor-pointer hover:text-white transition">
            T & Cs
          </span>
        </div>

      </div>

      {/* Custom CSS */}
      <style>{`

        /* Animated gradient text */
        @keyframes gradientMove {
          0% { background-position: 0% }
          100% { background-position: 200% }
        }
        .animate-gradient {
          background-size: 200% auto;
          animation: gradientMove 4s linear infinite;
        }

        /* Grid Animation */
        .animated-grid {
          background-image: linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px),
                            linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px);
          background-size: 50px 50px;
          animation: moveGrid 20s linear infinite;
        }

        @keyframes moveGrid {
          from { background-position: 0 0; }
          to { background-position: 100px 100px; }
        }

        /* Scanning Neon Line */
        .scanning-line::before {
          content: "";
          position: absolute;
          top: 0;
          left: -100%;
          width: 200%;
          height: 2px;
          background: linear-gradient(90deg, transparent, #ff00ff, transparent);
          animation: scan 6s linear infinite;
        }

        @keyframes scan {
          0% { top: 0%; }
          100% { top: 100%; }
        }

        /* Floating Particles */
        .particles::before {
          content: "";
          position: absolute;
          inset: 0;
          background-image: radial-gradient(rgba(255,255,255,0.3) 1px, transparent 1px);
          background-size: 25px 25px;
          opacity: 0.1;
          animation: floatParticles 30s linear infinite;
        }

        @keyframes floatParticles {
          from { background-position: 0 0; }
          to { background-position: 200px 200px; }
        }

        /* Login Button */
        .login-btn {
          background: linear-gradient(135deg, #6a00ff, #ff00cc);
          transition: 0.3s ease;
        }

        .login-btn:hover {
          transform: scale(1.05);
          box-shadow: 0 0 20px rgba(255,0,255,0.6);
        }

      `}</style>
    </div>
  );
};

export default Gameiosign;